import Box from '@mui/material/Box';
import React from 'react';
import { useSelector } from 'react-redux';
import { useOutlet, useParams } from 'react-router';
import ChannelsPanel from './ChannelsPanel';
import NoChannelPane from './NoChannelPane';

const MessagesScene = () => {
  const channelsPanelOpen = useSelector(state => state.header.channelsPannelOpen);
  const { channelId } = useParams();
  const outlet = useOutlet();
  // No selected chat (or a narrow viewport): keep the list visible so the scene is never a blank pane.
  const showChannels = channelsPanelOpen || !channelId;

  return (
    <Box
      component="section"
      sx={{
        height: '100%',
        display: 'flex',
        maxHeight: 'calc(100vh - 64px)',
      }}
    >
      <Box
        sx={{
          width: 380,
          height: '100%',
          display: showChannels ? 'block' : { xs: 'none', md: 'block' },
        }}
      >
        <ChannelsPanel />
      </Box>
      {outlet || <NoChannelPane />}
    </Box>
  );
};

export default MessagesScene;
